<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OBVSs5/tc-custom/9781460333228.jpg?1723259585169" alt="This image is the cover for the book Texan's Forbidden Fiancée, Lone Star Legends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texan's Forbidden Fiancée, Lone Star Legends
      </h1>
      <p class="bookDescription body article font2">
        <b>Star-crossed lovers are reunited during a search for buried treasure on a modern Texas ranch in this sexy romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>After a century-long family feud, Madison Milan doesn’t trust any Calhoun—especially Jake, the man who ditched her on the night of their elopement. But when he shows up claiming an heirloom map leads to gold on her ranch, she’s swamped by steamy memories. She may not trust Jake, but she still desires him. <br/><br/>Jake will do anything to get what he wants—Madison’s ranch. Consider it payback to the Milans. And Madison? She’s collateral damage in their family feud. The confident cowboy has nothing to worry about—except falling for the forbidden beauty all over again.<br/><br/>“Orwig’s latest is an interesting twist on a Hatfield and McCoy-type story. Readers who enjoy high-school sweetheart reunion stories should give this one a try.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Orwig
      </h2>
      
      <p class="authorDescription body article">Sara Orwig lives in Oklahoma and has a deep love of Texas. With a master&rsquo;s degree in English, Sara taught high school English, was Writer-in-Residence at the University of Central Oklahoma and was one of the first inductees into the Oklahoma Professional Writers Hall of Fame. Sara has written mainstream fiction, historical and contemporary romance. Books are beloved treasures that take Sara to magical worlds. She loves both reading and writing them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?267bdc94